import { mapVariants } from '../product/helpers';

const defaultStoreName = 'minipdp';

const getProduct = (state, storeName) => state[storeName] || {};
const getProductDetails = (state, storeName) => getProduct(state, storeName).details || {};
const getVariantMatrix = (state, storeName) =>
    getProductDetails(state, storeName).variantMatrix || [];
const getVariantOptions = (state, storeName = defaultStoreName) =>
    mapVariants(getVariantMatrix(state, storeName));

export default {
    getVariantOptions,
};
